import {HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {ILoginResponse} from './models/i-login-response';
import {JwtHelperService} from '@auth0/angular-jwt';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const jwtHelperService = new JwtHelperService();

  const stringifiedData: string|null = localStorage.getItem('accessData');
  const accessData: ILoginResponse | null = stringifiedData != null ? JSON.parse(stringifiedData) : null;
  const authorization: string = (accessData != null && !jwtHelperService.isTokenExpired(accessData.jwt)) ?
    `Bearer ${accessData.jwt}` : '';
  const newReq: HttpRequest<unknown> = req.clone({
    headers: req.headers.append('Authorization', authorization)
  })

  return next(newReq);
};
